// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1RIoD","imageUploader":"EGiftCard_imageUploader__BpUvV"};